import type { StackedBarData } from '@revelio/replots';

import type { BreakdownTimeseriesDataSet } from '../../DataProvider/types';

export const buildStackedBarTimeseriesData = (
  data: BreakdownTimeseriesDataSet['data']
): StackedBarData[] => {
  const dates = new Set<string>();
  const byDate = data.map((segment) => {
    const points = new Map<string, (typeof segment.breakdown)[number]>();
    segment.breakdown.forEach((point) => {
      if (point.date) {
        dates.add(point.date);
        points.set(point.date, point);
      }
    });
    return points;
  });

  return [...dates].sort().map((date) => ({
    group: date,
    values: data.map((segment, i) => ({
      label: segment.dim,
      value: byDate[i]?.get(date)?.value ?? 0,
      id: segment.id,
    })),
  }));
};
